import React from 'react';
import { InferableComponentEnhancerWithProps } from 'react-redux';
import { ReduxTypeUtils } from 'utils/ReduxTypeUtils';

import * as FormsTypes from 'reactApp/components/Forms/Forms.types';

import { FormikContext } from './FormikContext';

type Connector = <OwnProps, Values>() => InferableComponentEnhancerWithProps<
    { _formikContext: FormsTypes.ExtendedFormikProps<Values> },
    OwnProps
>;

export const connectFormikContext: Connector = () =>
    // @ts-ignore
    (WrappedComponent) => {
        return class FormikContextConnector extends React.PureComponent {
            render() {
                return (
                    <FormikContext.Consumer>
                        {(context) => {
                            return (
                                // @ts-ignore
                                <WrappedComponent
                                    {...this.props}
                                    _formikContext={context}
                                />
                            );
                        }}
                    </FormikContext.Consumer>
                );
            }
        };
    };

export const formikContextConnector = connectFormikContext();

export type FormikContextConnectorProps = ReduxTypeUtils.TypeOfConnector<
    typeof formikContextConnector
>;
